import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Seo from "@/seo/Seo";
import { SeoLayout, Prose, FaqBlock } from "@/components/site/SeoLayout";
import { SERVICES, SERVICE_ORDER, CITIES_META } from "@/seo/content";
import { serviceLd, faqLd, breadcrumbLd } from "@/seo/schema";

export default function ServicePage({ slug }) {
  const s = SERVICES[slug];
  const path = `/${slug}`;
  const others = SERVICE_ORDER.filter((x) => x !== slug);

  const breadcrumb = [
    { name: "Home", path: "/" },
    { name: s.label, path },
  ];

  return (
    <>
      <Seo
        title={s.seoTitle}
        description={s.metaDesc}
        path={path}
        jsonLd={[serviceLd(s.label, s.metaDesc, path), faqLd(s.faqs), breadcrumbLd(breadcrumb)]}
      />
      <SeoLayout breadcrumb={breadcrumb}>
        <span className="inline-flex rounded-full bg-blue-100 px-4 py-1.5 text-xs font-semibold uppercase tracking-widest text-blue-700">
          {s.label}
        </span>
        <h1 className="mt-5 font-heading text-4xl font-bold tracking-tight text-slate-900 sm:text-5xl">{s.h1}</h1>

        <Prose intro={s.intro} sections={s.sections} />

        <FaqBlock faqs={s.faqs} />

        {/* Internal links: other services */}
        <section className="mt-12">
          <h2 className="font-heading text-2xl font-semibold text-slate-900">Onze andere diensten</h2>
          <div className="mt-6 grid gap-4 sm:grid-cols-3">
            {others.map((o) => (
              <Link
                key={o}
                to={`/${o}`}
                className="group flex items-center justify-between rounded-2xl border border-slate-100 bg-white p-5 shadow-sm transition-all hover:-translate-y-0.5 hover:shadow-md"
              >
                <span className="font-medium text-slate-800">{SERVICES[o].label}</span>
                <ArrowRight className="h-4 w-4 text-blue-600 transition-transform group-hover:translate-x-1" />
              </Link>
            ))}
          </div>
        </section>

        {/* Internal links: cities */}
        <section className="mt-10">
          <h2 className="font-heading text-2xl font-semibold text-slate-900">{s.label} in uw regio</h2>
          <div className="mt-6 flex flex-wrap gap-2">
            {CITIES_META.map((c) => (
              <Link
                key={c.slug}
                to={`/${c.slug}`}
                className="rounded-full border border-slate-200 px-4 py-2 text-sm font-medium text-slate-700 hover:border-blue-600 hover:text-blue-700"
              >
                {c.city}
              </Link>
            ))}
          </div>
        </section>
      </SeoLayout>
    </>
  );
}
